import { aliveStatusOptions } from '../consts'

// 创建标签搜索选项数据（不使用 Hooks 的版本）
const createTagSearchOptions = (resourceTagList: any[]) => {
  const tagTreeOptions = resourceTagList.map(item => ({
    ...item,
    bindTotal: item?.tagCategoryNum,
    tagList: item?.tagList?.map(child => ({
      ...child,
      bindTotal: child?.tagNum,
    })),
  }))

  const treeData = tagTreeOptions?.map((item, index) => {
    const parentId = `parent_${index}`
    const parent = {
      id: parentId,
      name: item.tagCategoryName,
      total: item.bindTotal,
      children: [],
    }

    if (item.tagList && item.tagList?.length > 0) {
      parent.children = item.tagList?.map(tag => ({
        id: tag.tagId,
        name: tag.tagName,
        total: tag.bindTotal,
      }))
    }

    return parent
  })

  const createVNode = node => ({
    value: `${node.name}$${node.id}`,
    title: `${node.name} (${node.total})`,
  })

  const data = treeData?.map(item => {
    if (item.children) {
      return {
        value: item.name,
        title: `${item.name} (${item.total})`,
        children: item.children?.map(child => createVNode(child)),
      }
    } else {
      return {
        value: item.name,
        title: `${item.name} (${item.total})`,
      }
    }
  })

  return data
}

// 创建搜索选项配置
export const createSearchOptions = (resourceTagList: any[]) => [
  {
    label: '用例名称',
    value: 'name',
    type: 'input' as const,
  },
  {
    label: '用例标签',
    value: 'tagId',
    type: 'treeSelect' as const,
    options: createTagSearchOptions(resourceTagList) as any, // 临时使用 any 类型
  },
  {
    label: '存活状态',
    value: 'alive',
    type: 'select' as const,
    mode: 'multiple' as const,
    options: aliveStatusOptions,
  },
]

// 创建模板搜索选项配置
export const createTemplateSearchOptions = () => [
  {
    label: '模板名称',
    value: 'name',
    type: 'input' as const,
  },
]
